export const uGetOptionValue = function (value: any) {
    if (value == 'true' || value == 'false') {
        return JSON.parse(value);
    } else if (!isNaN(Number(value))) {
        return Number(value);
    } else {
        return value;
    }
}